import React from "react";
import Moment from "react-moment";
import { ColumnTypes } from './../table-view/TableTypes';

export default ({ label, data, classes, columnType = ColumnTypes.datetime, showCustomTitle = false, customTitle = null }) =>
(
<div className={classes.muDetailWrap}>
<div title={label} className={classes.muLabels}>{label}</div><div className={classes.muSeperator}>:</div> 
<div title={showCustomTitle && customTitle ? customTitle : data} className={classes.muDetails}>
  {data ? (columnType === ColumnTypes.date ? <Moment format="DD/MM/YYYY" titleFormat="DD/MM/YYYY" withTitle>{data}</Moment> : <Moment format="DD/MM/YYYY h:mm:ss A" titleFormat="DD/MM/YYYY h:mm:ss A" withTitle>{data}</Moment>) : null}
</div>
</div>
);

